import $ from 'jquery';

import "blueimp-file-upload/js/vendor/jquery.ui.widget.js";
import "blueimp-file-upload/js/jquery.iframe-transport.js";
import "blueimp-file-upload/js/jquery.fileupload.js";
import "blueimp-file-upload/js/jquery.fileupload-image.js";

export function initImageUpload($target, $container, $form, done) {

    //AS: initialize file upload for media form
    $target.fileupload({
        url: zmp_ajax.ajaxurl, dataType: 'json', dropZone: $target, add: function (e, data) {
            var uploadErrors = 0;
            var acceptFileTypes = /^image\/(gif|jpe?g|png)$/i;
            var maxFilesize = parseInt($(".wrapper.zelftest").attr("data-max-upload-size") ?? '');
            if (data.files[0]['type'].length && !acceptFileTypes.test(data.files[0]['type'])) {
                $container.find(".alert-incorrectfiletype").removeClass('d-none');
                uploadErrors++;
            }
            if (data.files[0]['size'] > maxFilesize) {
                $container.find(".alert-incorrectfilesize").removeClass('d-none');
                uploadErrors++;
            }
            if (uploadErrors == 0) {
                $form.find("#progress").removeClass('d-none');
                data.submit();
            }
        }, done: done, progressall: function (e, data) {
            var progress = parseInt(String(data.loaded / data.total * 100), 10);
            $form.find('#progress .progress-bar').css('width', progress + '%');

        }, stop: function (e) {
            $form.find(".progress-bar").removeAttr("style");
            $form.find(" #progress").addClass('d-none');
        }, fail: function (jqXHR, textStatus, errorThrown) {
            $container.find(".alert-imageuploadfailed").removeClass('d-none');
        }
    }).prop('disabled', !$.support.fileInput)
        .parent().addClass($.support.fileInput ? undefined : 'disabled');

}
